import { render } from "./edit.vue?vue&type=template&id=3325f2dc&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=3325f2dc&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3325f2dc"],['__file',"src/views/ticket/faq/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3325f2dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3325f2dc', __exports__)) {
    console.log('reload')
    api.reload('3325f2dc', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=3325f2dc&scoped=true", () => {
    console.log('re-render')
    api.rerender('3325f2dc', render)
  })

}


export default __exports__